"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RuleManager = void 0;
const LogManager_1 = require("../Logger/LogManager");
class RuleManager {
    constructor() {
        this.rules = new Map();
        this.cachedValues = new Set();
        this.endpointValues = new Map();
        this.logger = LogManager_1.logManager.getLogger();
        this.fetchEndpoint = (endpoint) => __awaiter(this, void 0, void 0, function* () {
            try {
                const url = new URL(endpoint);
                return yield fetch(url);
            }
            catch (error) {
                if (error instanceof TypeError) {
                    this.logger.error("Invalid url parsed to rule manager, url: " + endpoint);
                }
                return false;
            }
        });
    }
    addRule(rule) {
        if (this.rules.has(rule.id)) {
            this.cachedValues.clear();
            this.endpointValues.clear();
        }
        this.rules.set(rule.id, rule);
    }
    removeRule(ruleId) {
        this.rules.delete(ruleId);
    }
    initRules() {
        return __awaiter(this, void 0, void 0, function* () {
            let returnValue = false;
            for (const ruleObject of this.rules.values()) {
                if (ruleObject.type === "endpoint") {
                    if (this.endpointValues.has(ruleObject.id))
                        continue;
                    const response = yield this.fetchEndpoint(ruleObject.rule.url);
                    if (!response)
                        continue;
                    if (response.status !== 200)
                        continue;
                    if (response.headers.get("Content-Type") !== "application/json")
                        continue;
                    const body = yield response.json();
                    const propertyPath = ruleObject.rule.response_data.split(".");
                    let result = body;
                    propertyPath.forEach((property) => {
                        if (result === false)
                            return;
                        if (property in result) {
                            result = result[property];
                        }
                        else {
                            result = false;
                        }
                    });
                    if (result === false)
                        continue;
                    this.endpointValues.set(ruleObject.id, result);
                    returnValue = true;
                }
            }
            return returnValue;
        });
    }
    /**
     * Checks a given value against all registered rules.
     *
     * @param value The value to check.
     * @returns True if value matches a rule, false otherwise.
     */
    evaluateValue(value) {
        if (value && value.paid_level !== undefined) {
            if (RuleManager.paidLevel < parseInt(value.paid_level)) {
                return true;
            }
        }
        if (!value)
            return false;
        if (this.rules.size == 0)
            return false;
        // Evaluate each rule
        for (const ruleObject of this.rules.values()) {
            if (!(ruleObject.property in value))
                return false;
            const valueToCheck = value[ruleObject.property];
            // Check cached values first
            if (this.cachedValues.has(valueToCheck)) {
                return true;
            }
            // Static array values check
            if (ruleObject.type === "array" && ruleObject.rule.includes(valueToCheck)) {
                this.cachedValues.add(valueToCheck);
                return true;
            }
            // Callback function check
            if (ruleObject.type === "callback" && ruleObject.rule(valueToCheck)) {
                this.cachedValues.add(valueToCheck);
                return true;
            }
            // External API check
            if (ruleObject.type === "endpoint" && this.endpointValues.has(ruleObject.id)) {
                const values = this.endpointValues.get(ruleObject.id);
                if (values === null || values === void 0 ? void 0 : values.includes(valueToCheck)) {
                    this.cachedValues.add(valueToCheck);
                    return true;
                }
            }
        }
        return false;
    }
}
exports.RuleManager = RuleManager;
RuleManager.paidLevel = 0;
